import React, { useState, useEffect } from 'react';
import api from '../api';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import LoadingSpinner from './LoadingSpinner';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './LiveBusMap.css';

// Fix for default marker icon issue with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const LiveBusMap = () => {
  const [busLocations, setBusLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchBusLocations = async () => {
    try {
      setError('');
      const token = localStorage.getItem('token');
      const res = await api.get('/buses/locations', {
        headers: {
          'x-auth-token': token,
        },
      });
      setBusLocations(res.data);
      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching bus locations:', err.response ? err.response.data : err.message);
      setError('Failed to load bus locations');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBusLocations();
    const interval = setInterval(() => {
      fetchBusLocations();
    }, 5000); // Poll every 5 seconds

    return () => clearInterval(interval);
  }, []);

  if (isLoading) {
    return (
      <div className="live-bus-map-container">
        <LoadingSpinner size="medium" message="Loading bus locations..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="live-bus-map-container">
        <div className="error-message">
          <p>{error}</p>
          <button onClick={fetchBusLocations}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <MapContainer center={[22.5726, 88.3639]} zoom={10} className="live-bus-map">
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {busLocations.map((bus) => (
        <Marker key={bus._id} position={[bus.latitude, bus.longitude]}>
          <Popup>
            <b>Bus Number:</b> {bus.busNumber} <br />
            <b>Driver:</b> {bus.driver ? bus.driver.name : 'N/A'} <br />
            <b>Last seen:</b> {bus.locationUpdatedAt ? new Date(bus.locationUpdatedAt).toLocaleString() : 'N/A'}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default LiveBusMap;
